import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { participant_list_loading : true, participant_list: '', participant_list_error: false};

export function participantsList(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_PARTICIPANTS_LIST:
        return {
            participant_list_loading: true,
            participant_list: '',
            participant_list_error: false
        };
      case organisationConstants.RESPONSE_PARTICIPANTS_LIST:
        return {
            participant_list_loading: false,
            participant_list: action.participant_list,
            participant_list_error: false
        };
      case organisationConstants.ERROR_PARTICIPANTS_LIST:
        return { 
            participant_list_loading: false,
            participant_list: '',
            participant_list_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/getParticipantsList.reducer.js